<div class="appContentsContainer">
  <form
    [formGroup]="fieldPrintFormat"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle">
        <div class="pageTitle">
          {{ "printsFormats.titleEditFieldsOfFormats" | translate }}
        </div>
      </div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="cfDescCampo" for="cfDescCampo">Campo</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              type="text"
              formControlName="cfDescCampo"
              [readonly]="operation === 'edicion'"
              maxlength="128"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="cfLongMax" for="cfLongMax">Longitud</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="number" formControlName="cfLongMax" />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="cfObligatorio" for="cfObligatorio">Obligatorio</label>
            </div>
          </div>
          <div class="inputContainer">
            <select formControlName="cfObligatorio">
              <option value="S">Si</option>
              <option value="N">No</option>
              <option value="NA">No Aplica</option>
            </select>
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label id="cfTagXml" for="cfTagXml">Tag XML</label>
            </div>
          </div>
          <div class="inputContainer">
            <input type="text" formControlName="cfTagXml" maxlength="32" />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="formGroupButtons detalleFormGroupButtonsFooter">
        <div class="formButton" *ngIf="fieldPrintFormat.pristine">
          <button class="submitButton" (click)="goList()">
            <em class="fas fa-caret-square-left"></em>
          </button>
        </div>

        <div class="formButton" *ngIf="!fieldPrintFormat.pristine">
          <button class="submitButton" [swal]="confirmSwal">
            <em class="fas fa-caret-square-left"></em>
          </button>
        </div>

        <div
          class="formButton middleButtonAceptarContainer"
          *ngIf="operation === 'edicion'"
        >
          <div class="middleButtonAceptar formButton">
            <button type="submit" class="submitButton">
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goList()"
    >
    </swal>
  </form>
</div>
